<template>
  <div class="card application-card">
    <div class="card-content" :class="{ 'card-disabled': app.is_deactivated }">
      <div class="media">
        <div class="media-content">
          <p class="subtitle is-spaced" v-if="app.project_code">
            {{ app.project_code }}
          </p>
          <p class="title is-5">{{ app.name }}</p>
        </div>
        <div class="media-right">
          <span class="tag is-success is-small" v-if="app.flavor">
            <i class="mdi mdi-cellphone-settings-variant"></i>
            {{
              $t(`types.flavors.${app.flavor}`, { defaultValue: app.flavor })
            }}
          </span>
        </div>
      </div>
      <div>
        <slot></slot>
        <div class="help" v-if="app.created_at">
          {{ $t('applications.created_at', { date: fromNow(app.created_at) }) }}
        </div>
      </div>
    </div>
    <footer v-if="app.is_deactivated" class="card-footer">
      <a class="card-footer-item">
        {{ 'DEACTIVATED' }}
      </a>
    </footer>
    <footer v-else class="card-footer">
      <a class="card-footer-item" @click.prevent="$emit('go-to-app', app.id)">
        {{ $t('applications.view_dashboard') }}
        <i class="mdi mdi-chevron-right"></i>
      </a>
      <router-link
        class="card-footer-item"
        v-if="isDeveloperOrSpectator"
        :to="`/apps/${app.id}/activities`"
      >
        {{ $t('activities.info.title') }}
        <i class="mdi mdi-chevron-right"></i>
      </router-link>

      <div
        class="more-wrapper card-footer-item"
        v-if="isDeveloperOrSpectator"
        @click="showDropdown()"
      >
        <div class="more" :class="{ 'show-more-menu': active }">
          <MoreDotsButton></MoreDotsButton>
          <div class="more-menu">
            <div class="more-menu-caret">
              <div class="more-menu-caret-outer"></div>
              <div class="more-menu-caret-inner"></div>
            </div>
            <ul
              class="more-menu-items"
              tabindex="-1"
              role="menu"
              aria-labelledby="more-btn"
              aria-hidden="true"
            >
              <li class="more-menu-item" v-if="isDeveloper" role="presentation">
                <router-link
                  class="more-menu-btn"
                  role="menuitem"
                  :to="`/apps/${app.id}/api_keys?tab=active`"
                >
                  {{ $t('api_keys.info.api_key') }}
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
              </li>
              <li class="more-menu-item" v-if="isDeveloper" role="presentation">
                <router-link
                  class="more-menu-btn"
                  role="menuitem"
                  :to="`/apps/${app.id}/users`"
                >
                  {{ $t('users.info.users') }}
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
              </li>
              <li class="more-menu-item" role="presentation">
                <router-link
                  class="more-menu-btn"
                  role="menuitem"
                  :to="`/apps/${app.id}/webhooks`"
                  v-if="showWebhooksBtn"
                >
                  {{ $t('webhooks.info.webhook') }}
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
              </li>
              <li
                v-if="isCrashReportingEnabled"
                class="more-menu-item"
                role="presentation"
              >
                <router-link
                  class="more-menu-btn"
                  role="menuitem"
                  :to="`/crash-reporting/${app.account_id}/apps/${app.id}`"
                  v-if="showCrashReportingBtn"
                >
                  {{ $t('crash_detection.crash_detection') }}
                  <i class="mdi mdi-chevron-right"></i>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import * as moment from 'moment';

import MoreDotsButton from 'components/buttons/MoreDotsButton.vue';
import Dropdown from 'views/mixins/dropdown';
import { configs } from 'config';

export default {
  name: 'ApplicationCard',
  extends: Dropdown,

  components: {
    MoreDotsButton,
  },

  props: {
    app: {
      type: Object,
      required: true,
    },
    isDeveloper: {
      type: Boolean,
      required: true,
    },
    isDeveloperOrSpectator: {
      type: Boolean,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
    isCrashReportingEnabled: {
      type: Boolean,
    },
  },

  computed: {
    showWebhooksBtn() {
      return configs().HAS_FIREHOSE && this.isDeveloperOrSpectator;
    },
  },
  methods: {
    fromNow(date) {
      return moment(date).fromNow();
    },
    showDropdown() {
      return (this.active = !this.active);
    },
    showCrashReportingBtn() {
      return configs().HAS_CRASH_REPORTING && this.isDeveloperOrSpectator;
    },
  },
};
</script>

<style lang="scss" scoped></style>
